import type { CreateCourseDraftBodyLevel } from './createCourseDraftBodyLevel';
import type { CreateCourseDraftBodyPrice } from './createCourseDraftBodyPrice';
import type { CreateCourseDraftBodySectionsItem } from './createCourseDraftBodySectionsItem';

export type CreateCourseDraftBody = {
  /** @nullable */
  description?: string | null;
  /** @nullable */
  level?: CreateCourseDraftBodyLevel;
  /** @nullable */
  price?: CreateCourseDraftBodyPrice;
  /** @nullable */
  sections?: CreateCourseDraftBodySectionsItem[] | null;
  /** @nullable */
  thumbnailUrl?: string | null;
  title: string;
};
